import { useQuery } from '@tanstack/react-query';
import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';
import {
  getAttachmentsQueryKey,
  listAttachments,
} from '../../attachments/api/attachments.client.js';

export function useContactFiles(contactId: string) {
  return useEntityFiles('contact', contactId);
}

export function useEntityFiles(entity: 'contact' | 'deal' | 'company' | 'task', entityId: string) {
  const scope = useCurrentScope();
  return useQuery({
    queryKey: getAttachmentsQueryKey(scope?.workspaceId ?? 'anonymous', entity, entityId),
    queryFn: () => listAttachments(entity, entityId),
    enabled: scope !== null,
  });
}
